import React, { Component } from 'react'

export class permission extends Component {
  render() {

    // const roles = ['Super Admin', 'Admin', 'Editor', 'Controller', 'User', 'Viewer'];
    const roles = [{id: 1, name: 'Admin'}, {id: 2, name: 'Editor'}, {id: 3, name: 'Viewer'}];
    const permissions = [{id: 1, name: 'Permission1', role_id: 1}, {id: 2, name: 'Permission2', role_id: 1}, {id: 3, name: 'Permission3', role_id: 1}, 
      {id: 4, name: 'Permission4', role_id: 2}, {id: 5, name: 'Permission5', role_id: 3}]
    
    return (
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title"><strong>Role</strong></h5>
            {/* <a class="btn btn-xs btn-light" href="#">See all</a> */}
          </div>

          <table class="table table-hover table-has-action">
            <thead>
              {/* <tr>
              <th>#</th>
              {permissions.map((permission, index) => (
                <th>{permission.name}</th>
              ))}
              </tr> */}
              
            </thead>
            <tbody>
            <tr>
              <th>#</th>
              {permissions.map((permission, index) => (
                <th>{permission.name}</th>
              ))}
              </tr>
              
              {roles.map((role, index) => (
                <tr>
                  <td>{role.name}</td>
                  <td><input type='checkbox' /></td>
                  <td><input type='checkbox' /></td>
                  <td><input type='checkbox' /></td>
                  <td><input type='checkbox' /></td>
                  <td><input type='checkbox' /></td>
                </tr>
                
              ))};

            </tbody>
          </table>

        </div>
      </div>
    )
  }
}

export default permission